import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders, inject } from '@angular/core';
import { AuthService } from './services/auth.service';

import { AuthGuard } from './guards/auth.guard';
import { EffectsModule } from '@ngrx/effects';
import { select, Store, StoreModule } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { idToken } from './store/selectors/auth.selector';
import { reducer } from './store/reducers/auth.reducer';
import { RouterEffects } from './store/effects/router.effect';
import { AuthEffects } from './store/effects/auth.effect';
import { RouterModule } from '@angular/router';
import { AuthRoutingModule } from './auth-routing.module';
import { JwtInterceptorService } from './interceptors/jwt-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OidcConfig } from './conf/conf';

// Special module export
export const effects: any[] = [AuthEffects, RouterEffects];
export const getCurrentIdToken: Array<() => string> = [];

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('auth', reducer),
    EffectsModule.forFeature(effects),
    AuthRoutingModule,
    RouterModule
],
  exports: [],
})
export class AuthModule {
  static forRoot(config: OidcConfig = null): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard,
        AuthService,
        { provide: OidcConfig, useValue: config },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
      ]
    };
  }
  constructor() {
    const store = inject<Store<any>>(Store);

    getCurrentIdToken[0] = () => {
      let token: string;
      store.pipe(
          select(idToken),
          take(1)).subscribe((t) => token = t);
      return token;
    };
  }
}
